export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-check-3037689871f476ad0f80203b605ad414.svg";